// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen-wrapper > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.login-screen-wrapper .login-container-wrapper form div {
  justify-content: space-between;
}
.login-screen-wrapper .login-container-wrapper form div input {
  width: 36px !important;
  height: 36px;
  border: 1px solid #d0566e;
  border-radius: 8px;
  font-size: 14px;
  color: #000;
  font-weight: 400;
  caret-color: #d0566e;
}
.login-screen-wrapper .login-container-wrapper form div input:focus-within {
  outline: none;
}
.login-screen-wrapper .login-container-wrapper form .submit-btn {
  background-color: rgb(218, 103, 112) !important;
}
.login-screen-wrapper .login-container-wrapper form .submit-btn:hover {
  background-color: #b63f48 !important;
}

.login-input {
  border-bottom: 1px solid #d0566e;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginForm/Login.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AAAR;AAIY;EACI,8BAAA;AAFhB;AAIgB;EACI,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAFpB;AAIoB;EACI,aAAA;AAFxB;AAOY;EACI,+CAAA;AALhB;AAMgB;EACI,oCAAA;AAJpB;;AAYA;EACI,gCAAA;EACA,aAAA;AATJ","sourcesContent":[".login-screen-wrapper{\n    >img{\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n    }\n    .login-container-wrapper{\n        form{\n            div{\n                justify-content: space-between;\n\n                input{\n                    width: 36px!important;\n                    height: 36px;\n                    border: 1px solid #d0566e;\n                    border-radius: 8px;\n                    font-size: 14px;\n                    color: #000;\n                    font-weight: 400;\n                    caret-color: #d0566e;\n                    \n                    &:focus-within{\n                        outline: none;\n                    }\n                }\n            }\n\n            .submit-btn {\n                background-color: rgb(218, 103, 112) !important;\n                &:hover {\n                    background-color: #b63f48 !important;\n                }\n            }\n        }\n    }\n    \n}\n\n.login-input{\n    border-bottom: 1px solid #d0566e;\n    outline: none;\n}   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
